
/**
 * Function utilisée sur le formulaire "Envoyer un message" et "Se faire rappeler"
 * les formulaires sont présents sur toutes les pages agence ainsi que sur la page contact
 */

 (function(w) {
    w.Kinougarde = Object.assign({},w.Kinougarde, { Contact : {}});
    /**
     * Initialisation du formulaire
     */
    w.Kinougarde.Contact.initFormulaireContact = function() {    

        // Se faire rappeler
        $("#section-contact-form-rappel").on('submit', function(e) {
            e.preventDefault();
            w.Kinougarde.Contact.Submit($(this),"/seFaireRappeler/Confirmation/");
        });
        // Envoi message
        $("#section-contact-form-message").on('submit', function(e) {
            e.preventDefault();
            w.Kinougarde.Contact.Submit($(this),"/envoyerUnMessage/Confirmation/");
        });
    };

    /**
     * Envoie des données du formulaire
     */
    w.Kinougarde.Contact.Submit = function($form ,virtualPageURL) {            
        
        $form.parsley().validate();
        if ($form.parsley().isValid()) {   

            var data = {};
            // Recupère toutes les valeurs des champs du formualire pour les stocker dans un javascript
            $form.serializeArray().forEach(function(value, key){                                               
                if (data[value['name']]) {
                    if (!data[value['name']].push) {
                        data[value['name']] = [data[value['name']]];
                    }
                    data[value['name']].push(value['value'] || null);
                } else {
                    data[value['name']] = value['value'] || null;
                }
            });                  
            data = Object.assign(data,Kinougarde.GetGlobalUtmFields());

            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: ajax_kinougarde_object.ajaxurl,
                data: data,
                success: function (reponse) {
                    if (reponse.success===true) {
                        $form.hide().parent().find('.successfully-sent').show()
                        $('html, body').animate({
                            scrollTop: $form.hide().parent().find('.successfully-sent').offset().top - $('header').height()
                        }, 'slow');
                        kinougarde_tracking({
                            "event" : "VirtualPageview",
                            "virtualPageURL" : virtualPageURL,
                            "virtualPageTitle" : document.title
                        });
                        
                        Kinougarde.TagManagerTunnel(virtualPageURL);

                        //Au cas ou l'utilisateur remplie le deuxième formulaire, (se faire rappeler ou message)
                        // il faut réinitialiser la reponse captcha car elle ne peut servir qu'une seule fois
                        // La clé du site est dans gglcptch.options.sitekey
                        if (typeof(grecaptcha)!=='undefined' && typeof(gglcptch)!=='undefined') {
                            grecaptcha.execute(gglcptch.options.sitekey, { action: 'kinougarde_contact' }).then(function (token) {
                                $(".gglcptch [name=g-recaptcha-response]").each(function() {
                                    $(this).val(token);                                
                                })                        
                            });
                        }
                    } else if (reponse.success===false) {
                        // Code 200 , mais erreur métier, on affiche le message                       
                        var msg = Kinougarde.Form.getMessageErrorAjax(reponse);
                        $form.find("button").before(msg);                       
                    }
                },
                error: function (reponse) {
                    // Affichage d'un message d'erreur                             
                    var msg = Kinougarde.Form.getMessageErrorAjax(reponse);
                    $form.find("button").before(msg);

                }
            })
        }   
    }

})(window);
jQuery(function() {
    try {
        if (jQuery("#section-contact").length>0) {               
            Kinougarde.Contact.initFormulaireContact();
        }   
    }     
    catch (ex) {
        console.error(ex);
    }
});
